import { ResourceDescriptor } from "./common";

const user_email: ResourceDescriptor = {
    url: "user_email",
    orders: {
        create: ["address"],
    },
    identifiers: ["address"],
    expand: {},
    resourceSchemaPostProcessor: (schema) => {
        delete schema["tokens"];
    },
};

export default user_email;
